/**
 * @fileoverview Workspace Automations manager (MOR-736)
 *
 * URL: /dashboard/automations
 *
 * Firm-defined event-based automation rules: when a platform event happens
 * (task/day-one/report/agent/search), run actions (update tasks, notify,
 * remind, trigger searches). Lives under the workspace Tasks & Calendar
 * section beside Workflows.
 *
 * - Convex: automations.rules.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { AutomationsManager } from "@/components/settings/automations/AutomationsManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/automations",
)({
  component: AutomationsPage,
});

function AutomationsPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <AutomationsManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage automations.
        </div>
      )}
    </div>
  );
}
